var exports = {
  "kL": "x61f99309--d9675a--container",
  "Tq": "x61f99309--d9675a--bubble",
  "hD": "x61f99309--d9675a--quote",
  "Sl": "x61f99309--d9675a--image",
  "bD": "x61f99309--d9675a--image-info",
  "mI": "x61f99309--d9675a--meta",
};

module.exports = exports;
